import {
  STORAGE_ATTEMPT_NO,
  STORAGE_SAVE_ERROR_COUNT,
} from '../../components/common/Storage.js';
import { MIN_CONSECUTIVE_ERRORS } from '../../components/assessment/TestStatus.js';
import { getFromStorage } from '../common/StorageHelper.js';

export const NETWORK_ERROR_ACTION = {
  //no need to internatiolize this now, we use this in storage object, not user facing
  PREFIX: 'Network Error: ',
  LEARNOSITY: {
    type: 'LEARNOSITY',
    description: 'Learnosity connection lost.', //currently not using, once this is used, we can internationalize
  },
  WEBSOCKET: {
    type: 'WEBSOCKET',
    description: 'Websocket connection lost.', //currently not using, once this is used, we can internationalize
  },
};

export const hasNetworkErrors = () => {
  const maxReconnectAttemptsBeforeAuthOrReconnecting = parseInt(
    window.env.REACT_APP_WS_ATTEMPT_BEFORE_RECONNECTING_STATUS,
  );
  const __attemptNumber = getFromStorage(STORAGE_ATTEMPT_NO) || 0;
  const __saveErrorCount = getFromStorage(STORAGE_SAVE_ERROR_COUNT) || 0;
  return (
    __saveErrorCount >= MIN_CONSECUTIVE_ERRORS ||
    __attemptNumber >= maxReconnectAttemptsBeforeAuthOrReconnecting
  );
};
